export var SELECTOR_WIDTH = 330;
//# sourceMappingURL=constants.js.map